import { DeleteEmptyIcon } from './DeleteEmptyIcon';

/**
 * author: Austin Andrews
 * id E39FB607-9058-4C00-840C-AF666F372071
 * name delete-empty
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/delete-empty.svg
 * tags
 */
export const RubbishEmptyIcon = DeleteEmptyIcon;
export default RubbishEmptyIcon